import { Flex } from "@chakra-ui/react";
import React from "react";
import EditIndividual from "./components/EditIndividual";

function Data() {


  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <EditIndividual
      />
    </Flex>
  );
}

export default Data;
